import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

import { comoAcompanhamentoDoAr } from '../../utils/envioFisicoArViewModel';

const selectEstado = (state: RootState) => state.envioFisicoAr;

const selectEnviosFisicosArDto = (state: RootState) => state.envioFisicoAr.itens;

/** O modelo que o card desenha, derivado do DTO — o estado guarda só o que a API mandou. */
export const selectAcompanhamentosAr = createSelector(
  [selectEnviosFisicosArDto, (state: RootState) => state.envioFisicoAr.processoArbitralId],
  (itens, processoArbitralId) =>
    itens.map((item) => ({
      envioFisicoId: item.postal?.envioFisicoId ?? null,
      acompanhamento: comoAcompanhamentoDoAr(processoArbitralId ?? '', item),
    })),
);

export const selectPaginacaoEnvioFisicoAr = createSelector([selectEstado], (estado) => ({
  total: estado.total,
  pagina: estado.pagina,
  hasMore: estado.hasMore,
  carregando: estado.carregando,
  carregandoMais: estado.carregandoMais,
  carregado: estado.carregado,
  erro: estado.erro,
  paginaQueFalhou: estado.paginaQueFalhou,
}));

/** `envioFisicoId:tipo` → `requestId` de cada documento sendo aberto (ver o slice). */
export const selectDocumentosEmVooAr = (state: RootState) => state.envioFisicoAr.documentosEmVoo;
